import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CREHANA_DIPLOMAS_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, CREHANA_DIPLOMAS_TRANSLATION_KEY, {
  DIPLOMAS_TITLE: 'Tus diplomas',
  SEE_ALL: 'Ver todos',
  EMPTY_VIEW_TITLE: 'Aún no obtienes tu diplomas o certificado de participación.',
  EMPTY_VIEW_DESC: 'Para obtener un diploma deberás culminar una ruta de Academia y para obtener certificados de participación de Crehana solo debes terminar el 100% de visualización de tus clases.',
  EMPTY_VIEW_BUTTON: 'Ir a mis cursos',
  EMPTY_VIEW_BUTTON_PROJECT: 'Ir a mis proyectos',
  EMPTY_VIEW_DEGREE_DESC: 'Una vez que completes todos los cursos y entregues tus proyectos parciales, tendrás que avanzar tu proyecto final y aprobarlo para poder obtener tu diploma de MicroDegree.',
  EMPTY_VIEW_DEGREE_BUTTON: 'Ir a mi MicroDegree',
  DOWNLOAD_FILTER: 'Tipo de certificación',
  DOWNLOAD_FILTER_ALL: 'Todos ({{count}})',
  DOWNLOAD_FILTER_DIPLOMA: 'Diplomas ({{count}})',
  DOWNLOAD_FILTER_PROOF: 'Certificados ({{count}})',
  DOWNLOAD_DIPLOMA: 'DIPLOMA',
  DOWNLOAD_PROOF: 'CONSTANCIA',
  DOWNLOAD_DESCRIPTION_GENERAL: 'En total lograste {{diplomasCount}} diplomas y {{certificateCount}} constancias de participación'
});